import api from '@/interface/baseApi'

//获取素材列表
export function get(params) {
    return api({
        url: '/oms/stock/material/get',
        method: 'get',
        params:{
        	page: ('page' in params) ? params.page : 1,
			psize: ('psize' in params) ? params.psize : 20,
			kws: ('kws' in params) ? params.kws : '',
			orby: ('orby' in params) ? params.orby : '',
			sort: ('sort' in params) ? params.sort : '',
			type: ('type' in params) ? params.type : '',
			types: ('types' in params) ? params.types : [],
        }
    })
}

//企业微信资源临时凭证
export function wxmedia(params) {
    return api({
        url: '/oms/stock/material/wxmedia',
        method: 'get',
        params:{
            id: params.id,
            app: params.app,
        }
    })
}
